export function setItem(key: string, value: unknown) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error saving to sessionStorage', error);
  }
}

export function getItem(key: string) {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch (error) {
    console.error('Error reading from sessionStorage', error);
  }
}